import { jsxs as n, jsx as l } from "@emotion/react/jsx-runtime";
import { HeaderRowContainer as d } from "./HeaderRow.styled.js";
import { Checkbox as i } from "../../../Checkbox/index.js";
import { useTableContext as m } from "../../TableContext.js";
import { HeaderCell as b } from "../HeaderCell/HeaderCell.js";
const w = ({
  children: t,
  hasSelectAllColumn: o
}) => {
  const {
    allRowSelectValue: e,
    selectAll: a,
    unselectAll: r,
    selectedRowIds: c
  } = m(), s = Object.keys(c).length;
  return /* @__PURE__ */ n(d, { children: [
    o ? /* @__PURE__ */ l(b, { width: "24px", children: /* @__PURE__ */ l(i, { dataTrackId: "", name: "table-select-all-checkbox", value: "all", "aria-label": "select all", checked: e, onChange: e === !1 ? a : r, disabled: s === 0 }) }) : null,
    t
  ] });
};
export {
  w as HeaderRow
};
